import React from "react";
import {Home} from "lucide-react";
import {useLocation, useNavigate} from "react-router-dom";

export function Breadcrumbs() {
    const navigate = useNavigate();
    const location = useLocation();

    const getBreadcrumbs = () => {
        const path = location.pathname;
        const parts = path.split('/').filter(Boolean);

        return parts.map((part, index) => ({
            name: part.charAt(0).toUpperCase() + part.slice(1),
            path: '/' + parts.slice(0, index + 1).join('/')
        }));
    };

    return (
        <div className="flex items-center space-x-2 text-gray-500 text-sm mb-4">
            {getBreadcrumbs().map((crumb, index) => (
                <React.Fragment key={crumb.path}>
                    {index > 0 ? <span>/</span> : <></>}
                    <button
                        onClick={() => navigate(crumb.path)}
                        className="hover:text-indigo-600"
                    >
                        {index === 0 ? <Home className="h-4 w-4" /> : crumb.name}
                    </button>
                </React.Fragment>
            ))}
        </div>
    );
}